import React, {memo} from 'react';

import style from './anchor.module.scss';

const Anchor = memo(
	/**
	 * @param {{
	 *   anchor: string,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function Anchor({
		anchor
	}) {
		const ident = normalizeAnchorString(anchor);

		return (
			<span
				className={style.base}
				id={ident}
			/>
		);
	}
);

export default Anchor;

/**
 * @param {string} str
 * @returns {string}
 */
export function normalizeAnchorString(str) {
	return str
		.toLowerCase()
		.replace(/ü/g, 'ue')
		.replace(/ö/g, 'oe')
		.replace(/ä/g, 'ae')
		.replace(/ß/g, 'ss')
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}
